module.exports = "/_next/static/images/87c417da7fe627583f3acd2c2da42e84-el-pais.png";